import { Component, EventEmitter, Output, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IActiveDate, IDatepickerTheme, NgPersianDatepickerModule } from 'ng-persian-datepicker';

// const customTheme: Partial<IDatepickerTheme> = {
//   selectedBackground: '#D68E3A',
//   selectedText: '#FFFFFF',
// };

@Component({
  selector: 'app-persian-date-picker',
  standalone: true,
  imports: [NgPersianDatepickerModule, ReactiveFormsModule,],
  templateUrl: './persian-date-picker.component.html',
  styleUrl: './persian-date-picker.component.css'
})
export class PersianDatePickerComponent {

  
  dateValue = new FormControl('');
  @Output() dateSelected = new EventEmitter<string>();

  @ViewChild('dateInput') dateInput!: ElementRef<HTMLInputElement>;

  ngOnInit() {
    const today = new Date();
    const todayISO = today.toISOString().split('T')[0]; // Format YYYY-MM-DD
    this.dateValue.setValue(todayISO); // Set initial value in FormControl
    this.dateSelected.emit(todayISO);  // Emit initial value
  }

  ngAfterViewInit() {
    // Set input value directly after the view is initialized
    if (this.dateInput) {
      this.dateInput.nativeElement.value = this.dateValue.value!;
    }
  }

  onDateChange(event: IActiveDate) {
    if (event && event.gregorian) {
      const selectedDate = new Date(event.gregorian).toISOString().split('T')[0]; // Convert to YYYY-MM-DD
      this.dateValue.setValue(selectedDate); // Update form control
      this.dateSelected.emit(selectedDate); // Emit formatted date
    }
  }

  // dateValue = new FormControl();

  // @Output() dateSelected = new EventEmitter<string>();

  // onDateChange(event: any) {
  //   this.dateSelected.emit(event); // Adjust according to the library output
  // }

  // onSelect(event: IActiveDate): void {
  //   const selectedTime = event;
  //   const viaTimestampValue = event.timestamp;
  //   const viaGregorianDate = new Date(event.gregorian);

  //   // console.log(viaTimestampValue);
  //   // console.log(viaGregorianDate);
    
  // }

}
